<script setup>
import { computed } from 'vue';
import { t } from '../i18n';
import { PANEL } from '../ui';
import { pathSub, pathTitle } from '../achievements';

// Block 3 of «Достижения» (docs/achievements/SPEC.md, «Проект v2»): the last bright moments of the path, newest
// first; the whole path opens in a sheet.
const props = defineProps({
  // events from the API, newest first
  path: {
    type: Array,
    required: true,
  },
  // «Первый заход» before the start, or null
  before: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['open']);

const SHOWN = 3;

const shown = computed(() => props.path.slice(0, SHOWN));
const total = computed(() => props.path.length + (props.before?.path.length ?? 0));
</script>

<template>
  <section :class="PANEL">
    <h3 class="text-[1.0625rem] font-semibold text-slate-100 sm:text-base">
      {{ t('achievements.pathTitle') }}
    </h3>
    <p
      v-if="shown.length === 0"
      class="mt-2 text-[0.8125rem] text-slate-400"
    >
      {{ t('achievements.pathEmpty') }}
    </p>
    <ul
      v-else
      class="mt-2 divide-y divide-slate-800"
    >
      <li
        v-for="event in shown"
        :key="`${event.kind}-${event.date}-${event.value ?? ''}`"
        class="py-2.5"
      >
        <p class="text-[0.9375rem] text-slate-100 sm:text-sm">
          {{ pathTitle(event) }}
        </p>
        <p class="text-[0.8125rem] text-slate-400">
          {{ pathSub(event) }}
        </p>
      </li>
    </ul>
    <button
      v-if="total > shown.length"
      type="button"
      class="mt-2 h-11 w-full rounded-2xl bg-slate-800 text-[0.9375rem] font-medium text-slate-100 hover:bg-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 sm:rounded-lg sm:text-sm"
      @click="emit('open')"
    >
      {{ t('achievements.pathAll', { count: total }) }}
    </button>
  </section>
</template>
